export default __webpack_public_path__ + "static/media/pic4.b737a12b.jpg";